// src/components/SimpleFormComponents/SimpleAddressDefaultForm.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import { Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import SimpleInput from '../../SimpleInput';
import SimpleAddressZip from '../../SimpleAddressZip';
import { useSimpleFormContext } from '../../SimpleFormProvider';
import useFormElement from 'hooks/useFormElement';
import SimpleGoogleMap from '../../SimpleGoogleMap';
import SimpleCountry from 'components/SimpleComponents/SimpleCountry';
import { logErrorSilent } from 'utils/errorLogger';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const FIELD_SPAN = { xs: 24, sm: 12, lg: 6 }; // keeps equal width across breakpoints

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleAddressFormUS = ({
  subdocumentField,
  showNeighborhood = false,
  showAddressReference = false,
  showMap = false,
}) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { locked, updatingCoordinates } = useSimpleFormContext?.() || {};

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 4. LOCAL STATE
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 5. EFFECTS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 6. HANDLERS
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 7. LOCAL VARIABLES II
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <>
      <Row gutter={ROW_GUTTER}>
        {/* ADDRESS 1 */}
        <Col xs={24} sm={12} lg={12}>
          <SimpleInput
            name="address1"
            subdocumentField={subdocumentField}
            label="address_line_1"
            placeholder="Main St"
            // style={editableStyle}
          />
        </Col>
        {/* ADDRESS 1 */}
        {/* ADDRESS 2 */}
        <Col xs={24} sm={12} lg={12}>
          <SimpleInput
            name="address2"
            subdocumentField={subdocumentField}
            label="address_line_2"
            placeholder="Apt, Suite, Unit"
          />
        </Col>
        {/* ADDRESS 2 */}
      </Row>

      <Row gutter={ROW_GUTTER}>
        {/* STATE */}
        <Col xs={24} sm={6} lg={6}>
          <SimpleInput
            name="region"
            subdocumentField={subdocumentField}
            label="state"
            placeholder="CA"
            onChange={handleStateUppercase}
            maxLength={32} // keep flexible for international regions
          />
        </Col>
        {/* STATE */}
        {/* CITY */}
        <Col xs={24} sm={12} lg={12}>
          <SimpleInput
            name="city"
            subdocumentField={subdocumentField}
            label="city"
            placeholder="San Francisco"
            // style={editableStyle}
          />
        </Col>
        {/* CITY */}
        {/* POSTAL CODE */}
        <Col xs={24} sm={6} lg={6}>
          <SimpleAddressZip
            countryCode="US"
            name="zip"
            subdocumentField={subdocumentField}
            label="zip_code"
            placeholder="94105"
            loading={updatingCoordinates}
          />
        </Col>
        {/* POSTAL CODE */}
      </Row>
      {showMap ? (
        <Row gutter={ROW_GUTTER}>
          <Col xs={24}>
            <SimpleGoogleMap subdocumentField={subdocumentField} />
          </Col>
        </Row>
      ) : null}
    </>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleAddressFormUS;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function handleStateUppercase(ev) {
  const target = ev?.target;
  if (!target) return;
  const { selectionStart, selectionEnd } = target; // keep caret stable
  target.value = (target.value || '').toUpperCase().slice(0, 32);
  // let antd form re-sync value, then restore caret
  setTimeout(() => {
    try {
      target.setSelectionRange(selectionStart, selectionEnd);
    } catch (_) {}
  }, 0);
}
